import { useRouter } from 'next/router'
import React from 'react'

const Header = () => {
  const router = useRouter()
  const { type } = router.query
  const redirectType = type ? type[0] : ''

  return (
    <div
      className={`flex items-center justify-center mb-[42px] ${redirectType === 'login' ? '-mt-[60px]' : 'mt-[60px]'} `}
    >
      <img src='/images/shopflo_logo_onboarding.svg' alt='Shopflo Logo' />
    </div>
  )
}

export default Header
